import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { buildStaffLoginUrl, RETURN_URL_PARAM } from '../utils/authReturnUrl';

/**
 * Legacy URL: `/auth/employee` → staff sign-in on the workspace host.
 */
function EmployeeAuthPage() {
  const [searchParams] = useSearchParams();
  const raw = searchParams.get(RETURN_URL_PARAM) || `${window.location.pathname}${window.location.search}`;
  const target = buildStaffLoginUrl(raw);
  if (target.startsWith('http')) {
    window.location.replace(target);
    return null;
  }
  return <Navigate to={target} replace />;
}

export default EmployeeAuthPage;
